
var voices={
  "Arabic": [
    {
      "voice_id": "Arabic_CalmWoman",
      "description": [
        "Female, Adult, Calm, Ideal for Audiobooks and Serene Narration"
      ],
      "voice_name": "Samira",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Arabic_FriendlyGuy",
      "description": [
        "Male, Adult, Natural, Friendly"
      ],
      "voice_name": "Karim",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    }
  ],
  "Chinese (Cantonese)": [
    {
      "voice_id": "Cantonese_ProfessionalHost（F)",
      "description": [
        "Female, Adult, Neutral, Professional"
      ],
      "voice_name": "Wing Yan (穎欣)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Cantonese_GentleLady",
      "description": [
        "Female, Adult, Calm, Gentle"
      ],
      "voice_name": "Sze Ching (詩晴)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Cantonese_ProfessionalHost（M)",
      "description": [
        "Male, Adult, Neutral, Professional"
      ],
      "voice_name": "Ho Hin (浩軒)",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Cantonese_PlayfulMan",
      "description": [
        "Male, Adult, Soulful, Playful"
      ],
      "voice_name": "Lok Jai (樂仔)",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Cantonese_CuteGirl",
      "description": [
        "Female, Young Adult, Soothing, Cute"
      ],
      "voice_name": "Sum Yee (心怡)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Cantonese_KindWoman",
      "description": [
        "Female, Adult, Friendly, Kind"
      ],
      "voice_name": "Ka Wai (嘉慧)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    }
  ],
  "Chinese (Mandarin)": [
    {
      "voice_id": "Chinese (Mandarin)_Reliable_Executive",
      "description": [
        "Male, Middle-Aged, Steady, Reliable, Executive, Trustworthy"
      ],
      "voice_name": "Zhang Guoqiang (张国强)",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Chinese (Mandarin)_News_Anchor",
      "description": [
        "Female, Middle-Aged, Professional, Ideal for News Broadcasting"
      ],
      "voice_name": "Li Ruolan (李若兰)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Chinese (Mandarin)_Unrestrained_Young_Man",
      "description": [
        "Male, Adult, Unrestrained, Free-Spirited"
      ],
      "voice_name": "Zhou You (周游)",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Chinese (Mandarin)_Mature_Woman",
      "description": [
        "Female, Adult, Charming, Mature"
      ],
      "voice_name": "Su Man (苏曼)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Chinese (Mandarin)_Kind-hearted_Antie",
      "description": [
        "Female, Middle-Aged, Gentle, Kind-Hearted, Warm, Caring"
      ],
      "voice_name": "Wang Yi (王姨)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Chinese (Mandarin)_HK_Flight_Attendant",
      "description": [
        "Female, Middle-Aged, Polite, Flight Attendant, Southern Accent"
      ],
      "voice_name": "Xiao Jia (小嘉)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Chinese (Mandarin)_Humorous_Elder",
      "description": [
        "Male, Senior, Refreshing, Humorous, Northern Accent"
      ],
      "voice_name": "Lao Guo (老郭)",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Chinese (Mandarin)_Gentleman",
      "description": [
        "Male, Adult, Magnetic, Charismatic"
      ],
      "voice_name": "Chen Yi (陈逸)",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Chinese (Mandarin)_Warm_Bestie",
      "description": [
        "Female, Adult, Warm, Crisp, Bestie, Friendly, Clear"
      ],
      "voice_name": "Ai Lin (艾琳)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Chinese (Mandarin)_Stubborn_Friend",
      "description": [
        "Male, Adult, Uninhibited, Stubborn"
      ],
      "voice_name": "Da Niu (大牛)",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Chinese (Mandarin)_Sweet_Lady",
      "description": [
        "Female, Adult, Tender, Sweet"
      ],
      "voice_name": "Zhi Ruo (芷若)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Chinese (Mandarin)_Southern_Young_Man",
      "description": [
        "Male, Adult, Earnest, Southern Accent"
      ],
      "voice_name": "A Zheng (阿正)",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Chinese (Mandarin)_Wise_Women",
      "description": [
        "Female, Middle-Aged, Lyrical, Wise"
      ],
      "voice_name": "Jing Zhu (静姝)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Chinese (Mandarin)_Gentle_Youth",
      "description": [
        "Male, Young Adult, Gentle"
      ],
      "voice_name": "Si Yuan (思源)",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Chinese (Mandarin)_Warm_Girl",
      "description": [
        "Female, Young Adult, Soft, Warm"
      ],
      "voice_name": "Nuan Nuan (暖暖)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Chinese (Mandarin)_Male_Announcer",
      "description": [
        "Male, Middle-Aged, Magnetic, Announcer, Clear, Authoritative"
      ],
      "voice_name": "Zhong Han (钟翰)",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Chinese (Mandarin)_Kind-hearted_Elder",
      "description": [
        "Female, Senior, Kind, Gentle"
      ],
      "voice_name": "Ci Yan (慈雁)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Chinese (Mandarin)_Cute_Spirit",
      "description": [
        "Female, Youthful, Adorable, Cute, Sweet"
      ],
      "voice_name": "Ling Er (灵儿)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Chinese (Mandarin)_Radio_Host",
      "description": [
        "Male, Adult, Poetic, Radio Host, Smooth"
      ],
      "voice_name": "Hai Tao (海涛)",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Chinese (Mandarin)_Lyrical_Voice",
      "description": [
        "Male, Adult, Mellow, Lyrical, Smooth, Expressive"
      ],
      "voice_name": "Yu Fei (郁飞)",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Chinese (Mandarin)_Straightforward_Boy",
      "description": [
        "Male, Young Adult, Thoughtful, Straightforward"
      ],
      "voice_name": "Yi Chen (以辰)",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Chinese (Mandarin)_Sincere_Adult",
      "description": [
        "Male, Adult, Sincere, Encouraging"
      ],
      "voice_name": "Zhi Yang (志阳)",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Chinese (Mandarin)_Gentle_Senior",
      "description": [
        "Female, Senior, Gentle, Cozy"
      ],
      "voice_name": "Hui Zhen (惠珍)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Chinese (Mandarin)_Crisp_Girl",
      "description": [
        "Female, Young Adult, Warm, Crisp"
      ],
      "voice_name": "Xiao Xuan (小萱)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Chinese (Mandarin)_Pure-hearted_Boy",
      "description": [
        "Male, Young Adult, Committed, Pure-Hearted"
      ],
      "voice_name": "Chun Yu (纯宇)",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Chinese (Mandarin)_Soft_Girl",
      "description": [
        "Female, Adult, Welcoming, Soft, Southern Accent"
      ],
      "voice_name": "A Shan (阿善)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Chinese (Mandarin)_IntellectualGirl",
      "description": [
        "Female, Adult, Intellectual, Clear, Knowledgeable"
      ],
      "voice_name": "Ruo Bing (若冰)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Chinese (Mandarin)_Warm_HeartedGirl",
      "description": [
        "Female, Adult, Warm-Hearted, Caring"
      ],
      "voice_name": "Shan Yi (善怡)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Chinese (Mandarin)_Laid_BackGirl",
      "description": [
        "Female, Adult, Relaxed, Laid-Back"
      ],
      "voice_name": "Man Ni (漫妮)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Chinese (Mandarin)_ExplorativeGirl",
      "description": [
        "Female, Adult, Explorative, Curious"
      ],
      "voice_name": "Mo Ke (莫可)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Chinese (Mandarin)_Warm-HeartedAunt",
      "description": [
        "Female, Middle-Aged, Kind, Warm-Hearted"
      ],
      "voice_name": "Qin Ayi (秦阿姨)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Chinese (Mandarin)_BashfulGirl",
      "description": [
        "Female, Youthful, Bashful, Shy"
      ],
      "voice_name": "Xiao Wen (小雯)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Arrogant_Miss",
      "description": [
        "Female, Adult, Arrogant"
      ],
      "voice_name": "Leng Yan (冷嫣)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Robot_Armor",
      "description": [
        "Male, Adult, Electronic, Robotic, Suitable for Sci-Fi and Futuristic Content"
      ],
      "voice_name": "Lang Dian (零点)",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    }
  ],
  "Czech": [
    {
      "voice_id": "czech_male_1_v1",
      "description": [
        "Male, Young Adult, Serious, Assured, Presenter"
      ],
      "voice_name": "Lukáš",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "czech_female_5_v7",
      "description": [
        "Female, Adult, Steadfast, Suitable for Broadcasting"
      ],
      "voice_name": "Dagmar",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "czech_female_2_v2",
      "description": [
        "Female, Adult, Graceful, Elegant"
      ],
      "voice_name": "Eliška",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    }
  ],
  "Dutch": [
    {
      "voice_id": "Dutch_kindhearted_girl",
      "description": [
        "Female, Young Adult, Warm, Kind-Hearted"
      ],
      "voice_name": "Lotte",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Dutch_bossy_leader",
      "description": [
        "Male, Adult, Serious, Bossy Leader"
      ],
      "voice_name": "Hendrik",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    }
  ],
  "English (United States)": [
    {
      "voice_id": "English_radiant_girl",
      "description": [
        "Female, Young Adult, Radiant, Lively"
      ],
      "voice_name": "Chloe",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "English_magnetic_voiced_man",
      "description": [
        "Male, Adult, Magnetic, Persuasive, Ideal for Advertisements and Promotions"
      ],
      "voice_name": "Jackson",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "English_captivating_female1",
      "description": [
        "Female, Adult, Captivating, Ideal for News Reporting and Documentary Narration"
      ],
      "voice_name": "Victoria",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "English_Upbeat_Woman",
      "description": [
        "Female, Adult, Upbeat, Bright, Perfect for Energetic and Positive Messaging"
      ],
      "voice_name": "Summer",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "English_Trustworth_Man",
      "description": [
        "Male, Adult, Trustworthy, Resonant"
      ],
      "voice_name": "David",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "English_CalmWoman",
      "description": [
        "Female, Adult, Calm, Soothing"
      ],
      "voice_name": "Seraphina",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "English_Gentle-voiced_man",
      "description": [
        "Male, Adult, Gentle, Resonant"
      ],
      "voice_name": "Gabriel",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "English_ReservedYoungMan",
      "description": [
        "Male, Adult, Reserved, Cold"
      ],
      "voice_name": "Silas",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "English_PlayfulGirl",
      "description": [
        "Female, Child, Playful, Ideal for Cartoons and Children's Entertainment"
      ],
      "voice_name": "Piper",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "English_ManWithDeepVoice",
      "description": [
        "Male, Adult, Deep Voice, Commanding"
      ],
      "voice_name": "Alaric",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "English_FriendlyPerson",
      "description": [
        "Male, Adult, Friendly, Natural-Sounding, Approachable"
      ],
      "voice_name": "Wyatt",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "English_MatureBoss",
      "description": [
        "Female, Middle-Aged, Mature, Commanding"
      ],
      "voice_name": "Eleanor",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "English_Debator",
      "description": [
        "Male, Middle-Aged, Tough, Perfect for Debates and Assertive Arguments"
      ],
      "voice_name": "Brock",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "English_Steadymentor",
      "description": [
        "Male, Young Adult, Arrogant"
      ],
      "voice_name": "Chadwell",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "English_CaptivatingStoryteller",
      "description": [
        "Male, Senior, Captivating, Storyteller, Cold, Detached"
      ],
      "voice_name": "Alistair",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "English_PassionateWarrior",
      "description": [
        "Male, Young Adult, Energetic, Passionate Warrior"
      ],
      "voice_name": "Kaelen",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "English_Soft-spokenGirl",
      "description": [
        "Female, Youth, Adorable, Soft-Spoken"
      ],
      "voice_name": "Daisy",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "English_SereneWoman",
      "description": [
        "Female, Young Adult, Serene, Friendly, Calm, Welcoming"
      ],
      "voice_name": "Clara",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "English_ConfidentWoman",
      "description": [
        "Female, Young Adult, Confident, Firm, Assertive"
      ],
      "voice_name": "Morgan",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "English_BossyLeader",
      "description": [
        "Male, Adult, Bossy Leader, Commanding"
      ],
      "voice_name": "Sterling",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "English_StressedLady",
      "description": [
        "Female, Middle-Aged, Unsure, Stressed, Anxious"
      ],
      "voice_name": "Martha",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "English_AssertiveQueen",
      "description": [
        "Female, Young Adult, Assertive, Guarded"
      ],
      "voice_name": "Astrid",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "English_Jovialman",
      "description": [
        "Male, Middle-Aged, Jovial, Mature, Cheerful, Good-natured"
      ],
      "voice_name": "Barney",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "English_WhimsicalGirl",
      "description": [
        "Female, Young Adult, Whimsical, Wary"
      ],
      "voice_name": "Luna",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "English_Kind-heartedGirl",
      "description": [
        "Female, Young Adult, Kind-Hearted, Calm"
      ],
      "voice_name": "Hannah",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    }
  ],
  "English (Australian)": [
    {
      "voice_id": "English_Aussie_Bloke",
      "description": [
        "Male, Adult, Friendly, Bright"
      ],
      "voice_name": "Lachlan",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    }
  ],
  "English (India)": [
    {
      "voice_id": "English_Diligent_Man",
      "description": [
        "Male, Adult, Diligent, Sincere, Honesty, Hard, Work"
      ],
      "voice_name": "Arjun",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    }
  ],
  "English (United Kingdom)": [
    {
      "voice_id": "English_expressive_narrator",
      "description": [
        "Male, Adult, Expressive, Perfect for Engaging Audiobook Narration"
      ],
      "voice_name": "Sebastian",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "English_compelling_lady1",
      "description": [
        "Female, Adult, Compelling, Suitable for Broadcast and Formal Announcements"
      ],
      "voice_name": "Fiona",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "English_UpsetGirl",
      "description": [
        "Female, Young Adult, Sad"
      ],
      "voice_name": "Maisie",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "English_Graceful_Lady",
      "description": [
        "Female, Middle-Aged, Graceful, Elegant"
      ],
      "voice_name": "Beatrice",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "English_MaturePartner",
      "description": [
        "Male, Middle-Aged, Mature, Gentle, Suitable for A Caring and Supportive Partner Role"
      ],
      "voice_name": "Arthur",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "English_LovelyGirl",
      "description": [
        "Female, Youth, Lovely, Sweet"
      ],
      "voice_name": "Poppy",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "English_Deep-VoicedGentleman",
      "description": [
        "Male, Adult, Deep-Voiced, Wise, Experienced, Thoughtful"
      ],
      "voice_name": "Hastings",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "English_Wiselady",
      "description": [
        "Female, Middle-Aged, Wise, Genial, Kind"
      ],
      "voice_name": "Penelope",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "English_DecentYoungMan",
      "description": [
        "Male, Adult, Decent, Respectable, Polite, Well-Mannered"
      ],
      "voice_name": "Nigel",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "English_SentimentalLady",
      "description": [
        "Female, Middle-Aged, Sentimental, Elegant, Perfect for Nostalgic or Emotional Readings"
      ],
      "voice_name": "Rosemary",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "English_ImposingManner",
      "description": [
        "Female, Adult, Imposing, Commanding"
      ],
      "voice_name": "Gwendolyn",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "English_SadTeen",
      "description": [
        "Male, Young Adult, Frustrated, Perfect for A Teen Character Expressing Annoyance"
      ],
      "voice_name": "Toby",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "English_WiseScholar",
      "description": [
        "Male, Young Adult, Wise, Conversational Scholar"
      ],
      "voice_name": "Julian",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "English_PatientMan",
      "description": [
        "Male, Adult, Patient, Calm, Understanding"
      ],
      "voice_name": "Edmund",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "English_Comedian",
      "description": [
        "Male, Young Adult, Breezy Comedian, Humorous"
      ],
      "voice_name": "Archie",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "English_Strong-WilledBoy",
      "description": [
        "Male, Young Adult, Mature-Sounding, Strong-Willed"
      ],
      "voice_name": "Callum",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "English_AnimeCharacter",
      "description": [
        "Female, Middle-Aged, Sincere, Perfect for Trustworthy and Heartfelt Storytelling"
      ],
      "voice_name": "Helen",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    }
  ],
  "Finnish": [
    {
      "voice_id": "finnish_male_3_v1",
      "description": [
        "Female, Young Adult, Energetic, Upbeat"
      ],
      "voice_name": "Meea",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "finnish_male_1_v2",
      "description": [
        "Male, Young Adult, Deep, Friendly"
      ],
      "voice_name": "Otso",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "finnish_female_4_v1",
      "description": [
        "Female, Adult, Determined, Assertive"
      ],
      "voice_name": "Terhi",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    }
  ],
  "French": [
    {
      "voice_id": "French_Male_Speech_New",
      "description": [
        "Male, Adult, Level-Headed, Composed"
      ],
      "voice_name": "Marc",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "French_Female_News Anchor",
      "description": [
        "Female, Adult, Patient, Presenter, Calm, Clear"
      ],
      "voice_name": "Sandrine",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "French_CasualMan",
      "description": [
        "Male, Middle-Aged, Casual, Relaxed"
      ],
      "voice_name": "Pascal",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "French_MovieLeadFemale",
      "description": [
        "Female, Young Adult, Cinematic, Perfect for Film"
      ],
      "voice_name": "Léa",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "French_FemaleAnchor",
      "description": [
        "Female, Adult, Professional, Authoritative, Clear"
      ],
      "voice_name": "Florence",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "French_MaleNarrator",
      "description": [
        "Male, Adult, Classic, Ideal for Storytelling"
      ],
      "voice_name": "Olivier",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    }
  ],
  "German": [
    {
      "voice_id": "German_FriendlyMan",
      "description": [
        "Male, Middle-Aged, Sincere, Friendly"
      ],
      "voice_name": "Stefan",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "German_SweetLady",
      "description": [
        "Female, Adult, Animated, Sweet"
      ],
      "voice_name": "Leni",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "German_PlayfulMan",
      "description": [
        "Male, Adult, Lively, Spirited, Energy"
      ],
      "voice_name": "Jonas",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    }
  ],
  "Greek": [
    {
      "voice_id": "greek_male_1a_v1",
      "description": [
        "Male, Adult, Intellectual, Thoughtful Mentor"
      ],
      "voice_name": "Sokratis (Σωκράτης)",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Greek_female_1_sample1",
      "description": [
        "Female, Adult, Gentle"
      ],
      "voice_name": "Eleni (Ελένη)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Greek_female_2_sample3",
      "description": [
        "Female, Young Adult, Cheerful, Girl Next Door"
      ],
      "voice_name": "Nefeli (Νεφέλη)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    }
  ],
  "Hindi": [
    {
      "voice_id": "hindi_male_1_v2",
      "description": [
        "Male, Adult, Magnetic, Trustworthy, Advisor"
      ],
      "voice_name": "Advait (अद्वैत)",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "hindi_female_2_v1",
      "description": [
        "Female, Adult, Gentle, Tranquil"
      ],
      "voice_name": "Ananya (अनन्या)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "hindi_female_1_v2",
      "description": [
        "Female, Adult, Calm, News, Anchor"
      ],
      "voice_name": "Ishani (ईशानी)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    }
  ],
  "Indonesian": [
    {
      "voice_id": "Indonesian_SweetGirl",
      "description": [
        "Female, Young Adult, Cute, Sweet"
      ],
      "voice_name": "Bunga",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Indonesian_ReservedYoungMan",
      "description": [
        "Male, Young Adult, Cold, Reserved"
      ],
      "voice_name": "Adrian",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Indonesian_CharmingGirl",
      "description": [
        "Female, Adult, Alluring, Charming"
      ],
      "voice_name": "Sekar",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Indonesian_CalmWoman",
      "description": [
        "Female, Young Adult, Serene, Calm"
      ],
      "voice_name": "Kirana",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Indonesian_ConfidentWoman",
      "description": [
        "Female, Young Adult, Assertive, Confident"
      ],
      "voice_name": "Dian",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Indonesian_CaringMan",
      "description": [
        "Male, Young Adult, Compassionate, Caring"
      ],
      "voice_name": "Dimas",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Indonesian_BossyLeader",
      "description": [
        "Male, Adult, Calm, Authoritative, Bossy Leader"
      ],
      "voice_name": "Pak Baskoro",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Indonesian_DeterminedBoy",
      "description": [
        "Male, Young Adult, Mature, Resolute, Determination"
      ],
      "voice_name": "Satria",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Indonesian_GentleGirl",
      "description": [
        "Female, Young Adult, Soft-Spoken, Gentle"
      ],
      "voice_name": "Awanis",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    }
  ],
  "Italian": [
    {
      "voice_id": "Italian_BraveHeroine",
      "description": [
        "Female, Middle-Aged, Calm, Brave, Heroine"
      ],
      "voice_name": "Vittoria",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Italian_Narrator",
      "description": [
        "Male, Middle-Aged, Classic Narrator"
      ],
      "voice_name": "Alessandro",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Italian_WanderingSorcerer",
      "description": [
        "Female, Adult, Ruthless, Wandering, Sorcerer"
      ],
      "voice_name": "Morgana",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Italian_DiligentLeader",
      "description": [
        "Female, Adult, Calm, Diligent, Leader"
      ],
      "voice_name": "Beatrice",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    }
  ],
  "Japanese": [
    {
      "voice_id": "Japanese_IntellectualSenior",
      "description": [
        "Male, Adult, Mature, Intellectual"
      ],
      "voice_name": "Kaito (海斗)",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Japanese_DecisivePrincess",
      "description": [
        "Female, Adult, Firm, Decisive Princess"
      ],
      "voice_name": "Ayame (彩芽)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Japanese_LoyalKnight",
      "description": [
        "Male, Adult, Youthful, Loyal Knight"
      ],
      "voice_name": "Ren (蓮)",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Japanese_DominantMan",
      "description": [
        "Male, Middle-Aged, Mature, Dominant"
      ],
      "voice_name": "Kenji (健司)",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Japanese_SeriousCommander",
      "description": [
        "Male, Adult, Serious, Reliable"
      ],
      "voice_name": "Takeo (武夫)",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Japanese_ColdQueen",
      "description": [
        "Female, Adult, Distant, Cold"
      ],
      "voice_name": "Shizuka (静華)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Japanese_DependableWoman",
      "description": [
        "Female, Adult, Steady, Dependable"
      ],
      "voice_name": "Haruka (遥)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Japanese_GentleButler",
      "description": [
        "Male, Adult, Charming, Gentle Butler"
      ],
      "voice_name": "Sosuke (宗介)",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Japanese_KindLady",
      "description": [
        "Female, Adult, Charming, Kind"
      ],
      "voice_name": "Miwa (美和)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Japanese_CalmLady",
      "description": [
        "Female, Adult, Calm, Charming"
      ],
      "voice_name": "Shiori (詩織)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Japanese_OptimisticYouth",
      "description": [
        "Male, Adult, Cheerful, Optimistic"
      ],
      "voice_name": "Yuki (幸)",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Japanese_GenerousIzakayaOwner",
      "description": [
        "Male, Middle-Aged, Playful, Generous, Izakaya Owner"
      ],
      "voice_name": "Goro (五郎)",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Japanese_SportyStudent",
      "description": [
        "Male, Adult, Inviting, Sporty Student"
      ],
      "voice_name": "Daiki (大輝)",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Japanese_InnocentBoy",
      "description": [
        "Male, Adult, Inviting, Innocent"
      ],
      "voice_name": "Hinata (陽向)",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Japanese_GracefulMaiden",
      "description": [
        "Female, Adult, Sweet, Graceful Maiden"
      ],
      "voice_name": "Sakura (さくら)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    }
  ],
  "Korean": [
    {
      "voice_id": "Korean_AirheadedGirl",
      "description": [
        "Female, Adult, Cool, Composed"
      ],
      "voice_name": "Seo-yoon (서윤)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Korean_AthleticGirl",
      "description": [
        "Female, Youth, Robust, Athletic"
      ],
      "voice_name": "Ha-neul (하늘)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Korean_AthleticStudent",
      "description": [
        "Male, Young Adult, Energetic, Athletic Student"
      ],
      "voice_name": "Min-ho (민호)",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Korean_BraveAdventurer",
      "description": [
        "Female, Adult, Playful, Adventurous, Brave"
      ],
      "voice_name": "Nara (나라)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Korean_BraveFemaleWarrior",
      "description": [
        "Female, Young Adult, Resolute, Brave Warrior"
      ],
      "voice_name": "Ji-won (지원)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Korean_BraveYouth",
      "description": [
        "Male, Young Adult, Powerful, Brave"
      ],
      "voice_name": "Kang-woo (강우)",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Korean_CalmGentleman",
      "description": [
        "Male, Middle-Aged, Composed, Calm"
      ],
      "voice_name": "Park Sang-hoon (박상훈)",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Korean_CalmLady",
      "description": [
        "Female, Young Adult, Resilient, Determined"
      ],
      "voice_name": "Soo-jin (수진)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Korean_CaringWoman",
      "description": [
        "Female, Young Adult, Lively, Vibrant, Caring"
      ],
      "voice_name": "Eun-chae (은채)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Korean_CharmingElderSister",
      "description": [
        "Female, Middle-Aged, Playful, Mischievous, Charming, Elder Sister"
      ],
      "voice_name": "Hye-young (혜영)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Korean_CharmingSister",
      "description": [
        "Female, Middle-Aged, Seductive, Charming"
      ],
      "voice_name": "Mi-yeon (미연)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Korean_CheerfulBoyfriend",
      "description": [
        "Male, Middle-Aged, Sharp, Intense"
      ],
      "voice_name": "Jin-hyuk (진혁)",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Korean_CheerfulCoolJunior",
      "description": [
        "Male, Adult, Energetic, Spirited, Cheerful, Cool Junior"
      ],
      "voice_name": "Tae-oh (태오)",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Korean_CheerfulLittleSister",
      "description": [
        "Female, Adult, Energetic, Lively, Cheerful, Little Sister"
      ],
      "voice_name": "Da-in (다인)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Korean_ChildhoodFriendGirl",
      "description": [
        "Female, Young Adult, Polite, Reserved, Childhood Friend"
      ],
      "voice_name": "Ye-eun (예은)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Korean_CockyGuy",
      "description": [
        "Male, Young Adult, Playful, Mischievous, Cocky"
      ],
      "voice_name": "Jae-hyun (재현)",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Korean_ColdGirl",
      "description": [
        "Female, Adult, Aloof, Cold"
      ],
      "voice_name": "Min-seo (민서)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Korean_ColdYoungMan",
      "description": [
        "Male, Adult, Cold, Composed"
      ],
      "voice_name": "Do-yoon (도윤)",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Korean_ConfidentBoss",
      "description": [
        "Male, Middle-Aged, Deep, Commanding, Confident Boss"
      ],
      "voice_name": "Chairman Kang (강 회장님)",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Korean_ConsiderateSenior",
      "description": [
        "Male, Young Adult, Gentle, Mature, Considerate"
      ],
      "voice_name": "Woo-bin (우빈)",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Korean_DecisiveQueen",
      "description": [
        "Female, Young Adult, Sweet, Resolute, Decisive"
      ],
      "voice_name": "Lee Seol (이설)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Korean_DominantMan",
      "description": [
        "Male, Adult, Mature, Authoritative, Dominant"
      ],
      "voice_name": "Kwon Hyuk (권혁)",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Korean_ElegantPrincess",
      "description": [
        "Female, Adult, Graceful, Refined, Elegant Princess"
      ],
      "voice_name": "Seo-hyeon (서현)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Korean_EnchantingSister",
      "description": [
        "Female, Young Adult, Desirable, Charming, Enchanting Sister"
      ],
      "voice_name": "Chae-young (채영)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Korean_EnthusiasticTeen",
      "description": [
        "Male, Young Adult, Passionate, Lively"
      ],
      "voice_name": "Do-jin (도진)",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Korean_FriendlyBigSister",
      "description": [
        "Female, Middle-Aged, Charismatic, Alluring, Friendly, Big Sister"
      ],
      "voice_name": "Ji-soo (지수)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Korean_GentleBoss",
      "description": [
        "Male, Middle-Aged, Regal, Refined, Gentle Boss"
      ],
      "voice_name": "Director Han (한 이사님)",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Korean_GentleWoman",
      "description": [
        "Female, Young Adult, Strong-Willed, Gentle"
      ],
      "voice_name": "Da-eun (다은)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Korean_HaughtyLady",
      "description": [
        "Female, Young Adult, Cold, Distant, Haughty"
      ],
      "voice_name": "Yoo-na (유나)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Korean_InnocentBoy",
      "description": [
        "Male, Young Adult, Naive, Pure, Innocent"
      ],
      "voice_name": "Ha-joon (하준)",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Korean_IntellectualMan",
      "description": [
        "Male, Middle-Aged, Combative, Intellectual"
      ],
      "voice_name": "Professor Choi (최 교수님)",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Korean_IntellectualSenior",
      "description": [
        "Male, Young Adult, Magnetic, Intellectual"
      ],
      "voice_name": "Shin Yi-an (신이안)",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Korean_LonelyWarrior",
      "description": [
        "Male, Adult, Youthful, Daring, Lonely Warrior"
      ],
      "voice_name": "Geom (검)",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Korean_MatureLady",
      "description": [
        "Female, Middle-Aged, Refined, Elegant, Mature"
      ],
      "voice_name": "Madam Yoon (윤 여사님)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Korean_MysteriousGirl",
      "description": [
        "Female, Youth, Energetic, Lively, Mysterious"
      ],
      "voice_name": "Bi-joo (비주)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Korean_OptimisticYouth",
      "description": [
        "Male, Young Adult, Cheerful, Optimistic"
      ],
      "voice_name": "Chan-sol (찬솔)",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Korean_PlayboyCharmer",
      "description": [
        "Male, Young Adult, Seductive, Playboy, Charmer"
      ],
      "voice_name": "Joo-won (주원)",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Korean_PossessiveMan",
      "description": [
        "Male, Middle-Aged, Powerful, Authoritative, Possessive"
      ],
      "voice_name": "Director Gu (구 본부장님)",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Korean_QuirkyGirl",
      "description": [
        "Female, Youth, Adorable, Quirky"
      ],
      "voice_name": "Bbomi (뽀미)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Korean_ReliableSister",
      "description": [
        "Female, Middle-Aged, Powerful, Authoritative, Reliable"
      ],
      "voice_name": "Sang-mi (상미)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Korean_ReliableYouth",
      "description": [
        "Male, Young Adult, Gentle, Considerate, Reliable"
      ],
      "voice_name": "Min-su (민수)",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Korean_SassyGirl",
      "description": [
        "Female, Youth, Sassy"
      ],
      "voice_name": "Chae-rin (채린)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Korean_ShyGirl",
      "description": [
        "Female, Young Adult, Timid, Introverted"
      ],
      "voice_name": "Yoon-hee (윤희)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Korean_SoothingLady",
      "description": [
        "Female, Middle-Aged, Alluring, Soothing"
      ],
      "voice_name": "Sook-hee (숙희)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Korean_StrictBoss",
      "description": [
        "Male, Middle-Aged, Stern, Strict Boss"
      ],
      "voice_name": "Director Kim (김 이사님)",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Korean_SweetGirl",
      "description": [
        "Female, Middle-Aged, Soothing, Gentle, Sweet, Calm"
      ],
      "voice_name": "Hye-sook (혜숙)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Korean_ThoughtfulWoman",
      "description": [
        "Female, Young Adult, Mature, Contemplative, Thoughtful"
      ],
      "voice_name": "Soo-ah (수아)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Korean_WiseElf",
      "description": [
        "Female, Young Adult, Sweet, Ethereal, Wise Elf"
      ],
      "voice_name": "El-rin (엘린)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Korean_WiseTeacher",
      "description": [
        "Male, Middle-Aged, Sagacious, Wise Teacher"
      ],
      "voice_name": "Master Kang (강 사부님)",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    }
  ],
  "Polish": [
    {
      "voice_id": "Polish_male_1_sample4",
      "description": [
        "Male, Adult, Mature, Narrator"
      ],
      "voice_name": "Andrzej",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Polish_male_2_sample3",
      "description": [
        "Male, Adult, Broadcast Anchor"
      ],
      "voice_name": "Mariusz",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Polish_female_1_sample1",
      "description": [
        "Female, Adult, Calm"
      ],
      "voice_name": "Malwina",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Polish_female_2_sample3",
      "description": [
        "Female, Adult, Neutral, Casual"
      ],
      "voice_name": "Kasia",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    }
  ],
  "Portuguese": [
    {
      "voice_id": "Portuguese_SentimentalLady",
      "description": [
        "Female, Young Adult, Elegant, Sentimental"
      ],
      "voice_name": "Mariana",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Portuguese_BossyLeader",
      "description": [
        "Male, Adult, Calm, Formal, Bossy Leader"
      ],
      "voice_name": "Dr. Henrique",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Portuguese_Wiselady",
      "description": [
        "Female, Middle-Aged, Smooth, Wise"
      ],
      "voice_name": "Beatriz",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Portuguese_Strong-WilledBoy",
      "description": [
        "Male, Young Adult, Mature, Strong-Willed"
      ],
      "voice_name": "Tiago",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Portuguese_Deep-VoicedGentleman",
      "description": [
        "Male, Adult, Deep-Voiced, Gentleman"
      ],
      "voice_name": "Ricardo",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Portuguese_UpsetGirl",
      "description": [
        "Female, Young Adult, Sad, Upset"
      ],
      "voice_name": "Inês",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Portuguese_PassionateWarrior",
      "description": [
        "Male, Young Adult, Energetic, Passionate Warrior"
      ],
      "voice_name": "Rodrigo",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Portuguese_AnimeCharacter",
      "description": [
        "Female, Middle-Aged, Animated, Suitable for Anime Characters"
      ],
      "voice_name": "Lucinda",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Portuguese_ConfidentWoman",
      "description": [
        "Female, Young Adult, Clear, Firm, Confident"
      ],
      "voice_name": "Camila",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Portuguese_AngryMan",
      "description": [
        "Male, Young Adult, Serious, Anger"
      ],
      "voice_name": "Bruno",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Portuguese_CaptivatingStoryteller",
      "description": [
        "Male, Middle-Aged, Captivating, Ideal for Storytelling"
      ],
      "voice_name": "Eduardo",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Portuguese_Godfather",
      "description": [
        "Male, Middle-Aged, Serious, Godfather, Authority"
      ],
      "voice_name": "Dom Manuel",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Portuguese_ReservedYoungMan",
      "description": [
        "Male, Young Adult, Cold, Calm, Reserved"
      ],
      "voice_name": "Estevão",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Portuguese_SmartYoungGirl",
      "description": [
        "Female, Intelligent, Sharp, Clear"
      ],
      "voice_name": "Sofia",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Portuguese_Kind-heartedGirl",
      "description": [
        "Female, Young Adult, Calm, Kind-Hearted"
      ],
      "voice_name": "Clara",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Portuguese_Pompouslady",
      "description": [
        "Female, Young Adult, Pompous, Cartoon-Style"
      ],
      "voice_name": "Carlota",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Portuguese_Grinch",
      "description": [
        "Male, Adult, Cunning, Grinch-Like, Mischievous, Sly"
      ],
      "voice_name": "Gaspar",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Portuguese_Debator",
      "description": [
        "Male, Middle-Aged, Tough, Debater, Strong, Assertive"
      ],
      "voice_name": "Baltazar",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Portuguese_SweetGirl",
      "description": [
        "Female, Young Adult, Adorable, Sweet"
      ],
      "voice_name": "Mafalda",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Portuguese_AttractiveGirl",
      "description": [
        "Female, Adult, Alluring, Attractive"
      ],
      "voice_name": "Isadora",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Portuguese_ThoughtfulMan",
      "description": [
        "Male, Young Adult, Gentle, Thoughtful"
      ],
      "voice_name": "Diogo",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Portuguese_PlayfulGirl",
      "description": [
        "Female, Youth, Cutesy, Playful"
      ],
      "voice_name": "Margarida",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Portuguese_GorgeousLady",
      "description": [
        "Female, Adult, Playful, Gorgeous, Confidence"
      ],
      "voice_name": "Vanessa",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Portuguese_LovelyLady",
      "description": [
        "Female, Adult, Charismatic, Lovely"
      ],
      "voice_name": "Helena",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Portuguese_SereneWoman",
      "description": [
        "Female, Young Adult, Calm, Serene, Peaceful, Composed"
      ],
      "voice_name": "Madalena",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Portuguese_SadTeen",
      "description": [
        "Male, Teen, Frustrated, Sad"
      ],
      "voice_name": "Martim",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Portuguese_MaturePartner",
      "description": [
        "Male, Middle-Aged, Mature, Dependable, Warm"
      ],
      "voice_name": "Paulo",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Portuguese_Comedian",
      "description": [
        "Male, Young Adult, Humorous, Comedian"
      ],
      "voice_name": "José",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Portuguese_NaughtySchoolgirl",
      "description": [
        "Female, Young Adult, Inviting, Naughty, Schoolgirl"
      ],
      "voice_name": "Kika",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Portuguese_Narrator",
      "description": [
        "Female, Middle-Aged, Narrator, Perfect for Storytelling"
      ],
      "voice_name": "Teresa",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Portuguese_ToughBoss",
      "description": [
        "Female, Middle-Aged, Mature, Tough Boss"
      ],
      "voice_name": "Dra. Antónia",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Portuguese_Fussyhostess",
      "description": [
        "Female, Middle-Aged, Intense, Fussy"
      ],
      "voice_name": "Dona Odete",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Portuguese_Dramatist",
      "description": [
        "Male, Middle-Aged, Quirky, Dramatist"
      ],
      "voice_name": "Florindo",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Portuguese_Steadymentor",
      "description": [
        "Male, Young Adult, Arrogant, Mentor"
      ],
      "voice_name": "Frederico",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Portuguese_Jovialman",
      "description": [
        "Male, Middle-Aged, Jovial, Laughing"
      ],
      "voice_name": "Joaquim",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Portuguese_CharmingQueen",
      "description": [
        "Female, Adult, Bewitching, Charming"
      ],
      "voice_name": "Rainha Isabel",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Portuguese_SantaClaus",
      "description": [
        "Male, Middle-Aged, Joyful, Santa Claus"
      ],
      "voice_name": "Pai Natal Nicolau",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Portuguese_Rudolph",
      "description": [
        "Female, Young Adult, Naive, Rudolph"
      ],
      "voice_name": "Estrela",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Portuguese_Arnold",
      "description": [
        "Male, Adult, Steady, Arnold, Strong"
      ],
      "voice_name": "Máximo",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Portuguese_CharmingSanta",
      "description": [
        "Male, Middle-Aged, Attractive, Charming, Santa"
      ],
      "voice_name": "Claudio",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Portuguese_Ghost",
      "description": [
        "Male, Adult, Sensual, Ghost, Mysterious, Alluring"
      ],
      "voice_name": "Valério",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Portuguese_HumorousElder",
      "description": [
        "Male, Middle-Aged, Wacky, Humorous"
      ],
      "voice_name": "Tio Barnabé",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Portuguese_CalmLeader",
      "description": [
        "Male, Middle-Aged, Composed, Calm Leader"
      ],
      "voice_name": "Comandante Álvaro",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Portuguese_GentleTeacher",
      "description": [
        "Male, Adult, Mild, Gentle, Teacher"
      ],
      "voice_name": "Professor Jorge",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Portuguese_EnergeticBoy",
      "description": [
        "Male, Young Adult, Cheerful, Energetic"
      ],
      "voice_name": "Kiko",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Portuguese_ReliableMan",
      "description": [
        "Male, Adult, Steady, Reliable"
      ],
      "voice_name": "Manuel",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Portuguese_SereneElder",
      "description": [
        "Male, Middle-Aged, Reflective, Serene Elder"
      ],
      "voice_name": "Dom Silvestre",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Portuguese_GrimReaper",
      "description": [
        "Male, Adult, Sinister, Grim, Reaper, Dark, Ominous"
      ],
      "voice_name": "Ceifeiro",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Portuguese_AssertiveQueen",
      "description": [
        "Female, Young Adult, Firm, Assertive"
      ],
      "voice_name": "Rainha Constança",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Portuguese_WhimsicalGirl",
      "description": [
        "Female, Young Adult, Lovely, Whimsical"
      ],
      "voice_name": "Marisol",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Portuguese_StressedLady",
      "description": [
        "Female, Middle-Aged, Unsure, Stressed"
      ],
      "voice_name": "Dona Glória",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Portuguese_FriendlyNeighbor",
      "description": [
        "Female, Young Adult, Energetic, Friendly Neighbor"
      ],
      "voice_name": "Rita",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Portuguese_CaringGirlfriend",
      "description": [
        "Female, Middle-Aged, Dreamy, Caring, Girlfriend"
      ],
      "voice_name": "Celeste",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Portuguese_PowerfulSoldier",
      "description": [
        "Male, Young Adult, Youthful, Bold, Powerful Soldier"
      ],
      "voice_name": "Vasco",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Portuguese_FascinatingBoy",
      "description": [
        "Male, Young Adult, Approachable, Fascinating"
      ],
      "voice_name": "Gabriel",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Portuguese_RomanticHusband",
      "description": [
        "Male, Middle-Aged, Emotional, Romantic"
      ],
      "voice_name": "João Paulo",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Portuguese_StrictBoss",
      "description": [
        "Female, Young Adult, Robotic, Strict Boss"
      ],
      "voice_name": "Eng. Soraia",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Portuguese_InspiringLady",
      "description": [
        "Female, Young Adult, Commanding, Inspiring"
      ],
      "voice_name": "Vitória",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Portuguese_PlayfulSpirit",
      "description": [
        "Female, Young Adult, Animated, Playful, Spirit"
      ],
      "voice_name": "Lulú",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Portuguese_ElegantGirl",
      "description": [
        "Female, Young Adult, Dramatic, Elegant"
      ],
      "voice_name": "Leonor",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Portuguese_CompellingGirl",
      "description": [
        "Female, Young Adult, Persuasive, Compelling"
      ],
      "voice_name": "Aléxia",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Portuguese_PowerfulVeteran",
      "description": [
        "Male, Middle-Aged, Strong, Powerful"
      ],
      "voice_name": "Sargento Rocha",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Portuguese_SensibleManager",
      "description": [
        "Male, Middle-Aged, Charismatic, Sensible Manager"
      ],
      "voice_name": "Sr. Jorge",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Portuguese_ThoughtfulLady",
      "description": [
        "Female, Middle-Aged, Worried, Thoughtful"
      ],
      "voice_name": "Dona Piedade",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Portuguese_TheatricalActor",
      "description": [
        "Male, Middle-Aged, Animated, Theatrical Actor"
      ],
      "voice_name": "Fausto",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Portuguese_FragileBoy",
      "description": [
        "Male, Young Adult, Gentle, Fragile"
      ],
      "voice_name": "Dinis",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Portuguese_ChattyGirl",
      "description": [
        "Female, Young Adult, Conversational, Chatty"
      ],
      "voice_name": "Matilde",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Portuguese_Conscientiousinstructor",
      "description": [
        "Female, Young Adult, Youthful, Conscientious Instructor"
      ],
      "voice_name": "Francisca",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Portuguese_RationalMan",
      "description": [
        "Male, Adult, Thoughtful, Rational"
      ],
      "voice_name": "Artur",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Portuguese_WiseScholar",
      "description": [
        "Male, Young Adult, Conversational, Wise Scholar"
      ],
      "voice_name": "Mateus",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Portuguese_FrankLady",
      "description": [
        "Female, Middle-Aged, Agitated, Frank"
      ],
      "voice_name": "Lurdes",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Portuguese_DeterminedManager",
      "description": [
        "Female, Middle-Aged, Determined Manager"
      ],
      "voice_name": "Dra. Fernanda",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    }
  ],
  "Romanian": [
    {
      "voice_id": "Romanian_male_1_sample2",
      "description": [
        "Male, Adult, Neutral, Reliable"
      ],
      "voice_name": "Adrian",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Romanian_male_2_sample1",
      "description": [
        "Male, Adult, Energetic"
      ],
      "voice_name": "Vlad",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Romanian_female_1_sample4",
      "description": [
        "Female, Adult, Cheerful, Optimistic"
      ],
      "voice_name": "Simona",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Romanian_female_2_sample1",
      "description": [
        "Female, Adult, Gentle"
      ],
      "voice_name": "Loredana",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    }
  ],
  "Russian": [
    {
      "voice_id": "Russian_HandsomeChildhoodFriend",
      "description": [
        "Female, Child, Aggressive, Handsome, Childhood Friend"
      ],
      "voice_name": "Sasha",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Russian_BrightHeroine",
      "description": [
        "Female, Adult, Arrogant, Bright"
      ],
      "voice_name": "Ekaterina",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Russian_AmbitiousWoman",
      "description": [
        "Female, Adult, Demanding, Ambitious"
      ],
      "voice_name": "Viktoria",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Russian_ReliableMan",
      "description": [
        "Male, Middle-Aged, Steady, Reliable"
      ],
      "voice_name": "Nikolai",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Russian_CrazyQueen",
      "description": [
        "Female, Adult, Energetic, Crazy, Wild, Unpredictable"
      ],
      "voice_name": "Kira",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Russian_PessimisticGirl",
      "description": [
        "Female, Adult, Compassionate, Pessimistic"
      ],
      "voice_name": "Nadezhda",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Russian_AttractiveGuy",
      "description": [
        "Male, Adult, Deep-Voiced, Attractive"
      ],
      "voice_name": "Maksim",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Russian_Bad-temperedBoy",
      "description": [
        "Male, Adult, Charming, Bad-Tempered"
      ],
      "voice_name": "Artyom",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    }
  ],
  "Spanish": [
    {
      "voice_id": "Spanish_SereneWoman",
      "description": [
        "Female, Young Adult, Soothing, Serene"
      ],
      "voice_name": "Lucía",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Spanish_MaturePartner",
      "description": [
        "Male, Middle-Aged, Warm, Mature Partner"
      ],
      "voice_name": "Javier",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Spanish_CaptivatingStoryteller",
      "description": [
        "Male, Middle-Aged, Captivating, Perfect for Storytelling"
      ],
      "voice_name": "Mateo",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Spanish_Narrator",
      "description": [
        "Female, Middle-Aged, Ideal for Storytelling"
      ],
      "voice_name": "Rosa",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Spanish_WiseScholar",
      "description": [
        "Male, Young Adult, Conversational, Wise Scholar"
      ],
      "voice_name": "Hugo",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Spanish_Kind-heartedGirl",
      "description": [
        "Female, Young Adult, Bright, Kind-Hearted"
      ],
      "voice_name": "Elena",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Spanish_DeterminedManager",
      "description": [
        "Female, Middle-Aged, Businesslike, Determined Manager"
      ],
      "voice_name": "Victoria",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Spanish_BossyLeader",
      "description": [
        "Male, Adult, Businesslike, Bossy Leader"
      ],
      "voice_name": "Don Ricardo",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Spanish_ReservedYoungMan",
      "description": [
        "Male, Young Adult, Tranquil, Reserved"
      ],
      "voice_name": "Adrián",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Spanish_ConfidentWoman",
      "description": [
        "Female, Young Adult, Clear, Firm, Confident"
      ],
      "voice_name": "Claudia",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Spanish_ThoughtfulMan",
      "description": [
        "Male, Young Adult, Sober, Thoughtful"
      ],
      "voice_name": "Tomás",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Spanish_Strong-WilledBoy",
      "description": [
        "Male, Adult, Mature, Strong-Willed"
      ],
      "voice_name": "Marcos",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Spanish_SophisticatedLady",
      "description": [
        "Female, Adult, Refined, Sophisticated"
      ],
      "voice_name": "Isabel",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Spanish_RationalMan",
      "description": [
        "Male, Adult, Thoughtful, Rational"
      ],
      "voice_name": "Sergio",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Spanish_AnimeCharacter",
      "description": [
        "Female, Middle-Aged, Animated, Suitable for Anime Characters"
      ],
      "voice_name": "Paquita",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Spanish_Deep-tonedMan",
      "description": [
        "Male, Middle-Aged, Charismatic, Deep-Toned"
      ],
      "voice_name": "Alejandro",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Spanish_Fussyhostess",
      "description": [
        "Female, Middle-Aged, Intense, Fussy"
      ],
      "voice_name": "Doña Pilar",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Spanish_SincereTeen",
      "description": [
        "Male, Teen, Heartfelt, Sincere"
      ],
      "voice_name": "Leo",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Spanish_FrankLady",
      "description": [
        "Female, Adult, Agitated, Frank"
      ],
      "voice_name": "Carmen",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Spanish_Comedian",
      "description": [
        "Male, Young Adult, Humorous Comedian"
      ],
      "voice_name": "Santi",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Spanish_Debator",
      "description": [
        "Male, Middle-Aged, Tough Debater"
      ],
      "voice_name": "Don Arturo",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Spanish_ToughBoss",
      "description": [
        "Female, Middle-Aged, Mature, Tough Boss"
      ],
      "voice_name": "Doña Valeria",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Spanish_Wiselady",
      "description": [
        "Female, Middle-Aged, Neutral, Wise"
      ],
      "voice_name": "Beatriz",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Spanish_Steadymentor",
      "description": [
        "Male, Young Adult, Arrogant, Steady Mentor"
      ],
      "voice_name": "Frederico",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Spanish_Jovialman",
      "description": [
        "Male, Senior, Gravelly, Jovial"
      ],
      "voice_name": "Tio Paco",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Spanish_SantaClaus",
      "description": [
        "Male, Senior, Joyful, Santa Claus"
      ],
      "voice_name": "Papá Noel Nicolás",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Spanish_Rudolph",
      "description": [
        "Male, Young Adult, Naive, Rudolph"
      ],
      "voice_name": "Rodolfo",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Spanish_Intonategirl",
      "description": [
        "Female, Young Adult, Versatile"
      ],
      "voice_name": "Natalia",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Spanish_Arnold",
      "description": [
        "Male, Adult, Steady, Arnold"
      ],
      "voice_name": "Maximiliano",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Spanish_Ghost",
      "description": [
        "Male, Adult, Raspy, Ghost"
      ],
      "voice_name": "Lázaro",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Spanish_HumorousElder",
      "description": [
        "Male, Senior, Eccentric, Humorous"
      ],
      "voice_name": "Don Filemón",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Spanish_EnergeticBoy",
      "description": [
        "Male, Young Adult, Cheerful, Energetic"
      ],
      "voice_name": "Javi",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Spanish_WhimsicalGirl",
      "description": [
        "Female, Young Adult, Witty, Whimsical"
      ],
      "voice_name": "Ximena",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Spanish_StrictBoss",
      "description": [
        "Female, Young Adult, Commanding, Strict Boss"
      ],
      "voice_name": "Dra. Belén",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Spanish_ReliableMan",
      "description": [
        "Male, Adult, Steady, Reliable"
      ],
      "voice_name": "Manuel",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Spanish_SereneElder",
      "description": [
        "Male, Senior, Reflective, Serene"
      ],
      "voice_name": "Don Aurelio",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Spanish_AngryMan",
      "description": [
        "Male, Young Adult, Intense, Angry"
      ],
      "voice_name": "Íñigo",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Spanish_AssertiveQueen",
      "description": [
        "Female, Young Adult, Firm, Assertive"
      ],
      "voice_name": "Reina Leticia",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Spanish_CaringGirlfriend",
      "description": [
        "Female, Adult, Dreamy, Caring, Girlfriend"
      ],
      "voice_name": "Estela",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Spanish_PowerfulSoldier",
      "description": [
        "Male, Young Adult, Youthful, Bold, Powerful Soldier"
      ],
      "voice_name": "Rodrigo",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Spanish_PassionateWarrior",
      "description": [
        "Male, Young Adult, Energetic, Passionate Warrior"
      ],
      "voice_name": "Fernán",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Spanish_ChattyGirl",
      "description": [
        "Female, Young Adult, Conversational, Chatty"
      ],
      "voice_name": "Martina",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Spanish_RomanticHusband",
      "description": [
        "Male, Middle-Aged, Emotional, Romantic"
      ],
      "voice_name": "Julián",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Spanish_CompellingGirl",
      "description": [
        "Female, Young Adult, Persuasive, Compelling"
      ],
      "voice_name": "Valeria",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Spanish_PowerfulVeteran",
      "description": [
        "Male, Middle-Aged, Strong, Powerful"
      ],
      "voice_name": "Sargento Valero",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Spanish_SensibleManager",
      "description": [
        "Male, Adult, Charismatic, Sensible Manager"
      ],
      "voice_name": "Alberto",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Spanish_ThoughtfulLady",
      "description": [
        "Female, Adult, Worried, Thoughtful"
      ],
      "voice_name": "Doña Mercedes",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    }
  ],
  "Thai": [
    {
      "voice_id": "Thai_male_1_sample8",
      "description": [
        "Male, Adult, Magnetic, Serene"
      ],
      "voice_name": "Pakorn (ปกรณ์)",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Thai_male_2_sample2",
      "description": [
        "Male, Adult, Lively, Friendly"
      ],
      "voice_name": "Win (วิน)",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    },
    {
      "voice_id": "Thai_female_1_sample1",
      "description": [
        "Female, Adult, Neutral, Confident"
      ],
      "voice_name": "Naphat (นภัส)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Thai_female_2_sample2",
      "description": [
        "Female, Adult, Energetic"
      ],
      "voice_name": "Ploy (พลอย)",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    }
  ],
  "Turkish": [
    {
      "voice_id": "Turkish_CalmWoman",
      "description": [
        "Female, Adult, Calm, Ideal for Audiobooks"
      ],
      "voice_name": "Elif",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Turkish_Trustworthyman",
      "description": [
        "Male, Adult, Resonant, Trustworthy"
      ],
      "voice_name": "Kerem",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    }
  ],
  "Ukrainian": [
    {
      "voice_id": "Ukrainian_CalmWoman",
      "description": [
        "Female, Adult, Calm, Ideal for Audiobooks"
      ],
      "voice_name": "Larysa",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    },
    {
      "voice_id": "Ukrainian_WiseScholar",
      "description": [
        "Male, Young Adult, Conversational, Wise Scholar"
      ],
      "voice_name": "Ostap",
      "created_time": "2025-01-01",
      "tag": [
        "M"
      ]
    }
  ],
  "Vietnamese": [
    {
      "voice_id": "Vietnamese_kindhearted_girl",
      "description": [
        "Female, Young Adult, Warm, Kind-Hearted"
      ],
      "voice_name": "Mai Chi",
      "created_time": "2025-01-01",
      "tag": [
        "F"
      ]
    }
  ]
};
// $.get('/voices.php',function(res){
//     voices=res.data.system_voice
//     console.log(voices)
for(var key in voices){
    $('.form-select').append(`<option>${key}</option>`)
    $('.form-select').val('English (United States)')
}
for(var i=0;i<voices['English (United States)'].length;i++){
    var genderIcon = voices[$('.form-select').val()][i].tag[0] === 'F'
        ? '<i class="gender-female"></i>'
        : '<i class="gender-male"></i>';
    $('.voice-selector—list').append(`
        <li data-tag="${voices[$('.form-select').val()][i].tag[0]}">
            <div class="voice-item-content">
                <div class="voice-item-text">
                    <p class="name" voice_id="${voices[$('.form-select').val()][i].voice_id}">${voices[$('.form-select').val()][i].voice_name}</p>
                    <p class="info">${voices[$('.form-select').val()][i].description[0]}</p>
                </div>
                ${genderIcon}
            </div>
        </li>    
    `)
}
// })